<template>
  <RouterView />
</template>

<script>
import EventFormDialog from '@/components/Application/Sales/Events/Event/CreateDialog'
import OpportunityFormDialog from '@/components/Application/Sales/Opportunities/Opportunity/Form/Dialog'
import Vue from 'vue'
import { READ, CREATE, UPDATE } from '@/plugins/user'

export default {
  data () {
    return {
      title: 'Sales',
      breadcrumb: {
        name: 'Sales',
        route: { name: 'sales' }
      },
      actions: [
        {
          hidden: this.$user.cannot(CREATE, this.$sdk.account_event),
          name: 'New Event',
          icon: ['fal', 'plus'],
          event: () => this.createEvent()
        },
        {
          hidden: this.$user.cannot(CREATE, this.$sdk.account_lead),
          name: 'New Opportunity',
          icon: ['fal', 'plus'],
          event: () => this.createOpportunity()
        }
      ],
      sidebar: [
        {
          icon: ['fal', 'chart-line'],
          route: { name: 'sales-dashboard' },
          name: 'Dashboard'
        },
        {
          icon: ['fal', 'rss'],
          route: { name: 'feed' },
          name: 'Feed'
        },
        {
          hidden: this.$user.cannot([READ, CREATE, UPDATE], this.$sdk.account_event),
          icon: ['fal', 'tasks'],
          route: { name: 'sales-todo' },
          name: 'To-Do'
        },
        {
          hidden: this.$user.cannot(READ, this.$sdk.account),
          icon: ['fal', 'briefcase'],
          route: { name: 'sales-accounts' },
          name: 'Accounts'
        },
        {
          hidden: this.$user.cannot(READ, this.$sdk.account_lead),
          icon: ['fal', 'bullseye-arrow'],
          route: { name: 'sales-opportunities' },
          name: 'Opportunities'
        },
        {
          hidden: this.$user.cannot(READ, this.$sdk.budget),
          icon: ['fal', 'user-chart'],
          route: { name: 'sales-budgets' },
          name: 'Budgets'
        },
        {
          hidden: this.$user.cannot(READ, this.$sdk.account_lead),
          icon: ['fal', 'funnel-dollar'],
          route: { name: 'sales-pipes' },
          name: 'Pipes'
        }
      ],
      eventFormDialogVisible: false,
      opportunityFormDialogVisible: false,
      eventFormDialogInstance: undefined,
      opportunityFormDialogInstance: undefined
    }
  },
  watch: {
    eventFormDialogVisible (visible) {
      if (!visible && typeof this.eventFormDialogInstance !== 'undefined') {
        this.eventFormDialogInstance.$destroy()
        this.eventFormDialogInstance.$el.remove()
        this.eventFormDialogInstance = undefined
      }
    },
    opportunityFormDialogVisible (visible) {
      if (!visible && typeof this.opportunityFormDialogInstance !== 'undefined') {
        this.opportunityFormDialogInstance.$destroy()
        this.opportunityFormDialogInstance.$el.remove()
        this.opportunityFormDialogInstance = undefined
      }
    }
  },
  methods: {
    createEvent (event) {
      const EventFormDialogClass = Vue.extend(EventFormDialog)
      const propsData = {
        event: event instanceof this.$sdk.account_event ? event : new this.$sdk.account_event()
      }

      if (event instanceof this.$sdk.account_event) {
        propsData.cancellable = false
        propsData.disabledFields = [
          (event.account ? 'account' : undefined),
          (event.type ? 'type' : undefined)
        ]
      }

      this.eventFormDialogInstance = new EventFormDialogClass({
        propsData
      })

      this
        .eventFormDialogInstance
        .$on('destroy', () => {
          this.eventFormDialogVisible = false
        })

      this
        .eventFormDialogInstance
        .$mount()

      this
        .$root
        .$el
        .appendChild(this.eventFormDialogInstance.$el)

      this.eventFormDialogVisible = true
    },
    createOpportunity () {
      const OpportunityFormDialogClass = Vue.extend(OpportunityFormDialog)

      this.opportunityFormDialogInstance = new OpportunityFormDialogClass({
        propsData: {
          opportunity: new this.$sdk.account_lead()
        }
      })

      this
        .opportunityFormDialogInstance
        .$on('destroy', () => {
          this.opportunityFormDialogVisible = false
        })

      this
        .opportunityFormDialogInstance
        .$on('new-event', (newEvent) => {
          this.createEvent(newEvent)
        })

      this
        .opportunityFormDialogInstance
        .$mount()

      this
        .$root
        .$el
        .appendChild(this.opportunityFormDialogInstance.$el)

      this.opportunityFormDialogVisible = true
    }
  }
}
</script>
